export default "__VITE_ASSET__CnLEdQbE__"